module.exports = __webpack_public_path__ + "static/media/avatarchat-icon.ba84a7e7.webp";